import BookingStatus from './BookingStatus';
export default BookingStatus;
